import type { LoanAgreementStatus } from "@/contracts";
import {
  IconCircleCheck,
  IconFileText,
  IconSend,
  IconTrash,
  IconLock,
} from "@tabler/icons-react";

import { Badge } from "@/components/ui/badge";
import { LOAN_STATUS_LABELS, LOAN_STATUS_TONES } from "./loan-labels";

export function LoanStatusBadge({ value }: { value: LoanAgreementStatus }) {
  const icon =
    value === "DRAFT"
      ? IconFileText
      : value === "ISSUED"
        ? IconSend
        : value === "SIGNED"
          ? IconCircleCheck
          : value === "CLOSED"
            ? IconLock
            : IconTrash;

  return (
    <Badge tone={LOAN_STATUS_TONES[value]} icon={icon}>
      {LOAN_STATUS_LABELS[value]}
    </Badge>
  );
}
